<section class="text-center">
  <div class="text-danger">{{error}}</div>
</section>
